import gql from "graphql-tag";

export const MY_DOCUMENTS_GET_LIST = gql`
  query listMyDocuments($user: String!) {
    listMyDocuments(user: $user) {
      _id
      filename
      size
      slug
      description
      user
      userView
      createdAt
      createdBy
    }
  }
`;
